import { CandidateDirectory } from "@container/employer-candidate-directory";
import { DashboardLayout } from "@container/layout/dashboard";
import { StartupCandidateDirectory } from "@container/startup-candidate-directory";
import { getCookie } from "@util/cookie";

export default function EmployerDashboardPage() {
    const isAccountStartupScreening: boolean = Boolean(getCookie("__account_startup_screening__"));
    return (
        <DashboardLayout>
            {isAccountStartupScreening ? (
                <StartupCandidateDirectory />
            ) : (
                <CandidateDirectory />
            )}
        </DashboardLayout>
    );
}
